export * from './status-medicao.enum';
